import { BaseApi } from './base.api.js';

export class DataSourceApi extends BaseApi {
    constructor(client) {
        super(client, '/data-source');
    }
}
